package com.kanati.admin.app

enum class AdminRouteScope {
    DISTRICT,
    SCHOOL,
}

enum class AdminRoute(
    val label: String,
    val scope: AdminRouteScope,
) {
    Dashboard("Home", AdminRouteScope.SCHOOL),
    Products("Products", AdminRouteScope.SCHOOL),
    Inventory("Inventory", AdminRouteScope.SCHOOL),
    Events("Events", AdminRouteScope.SCHOOL),
    Loyalty("Loyalty", AdminRouteScope.SCHOOL),
    Reports("Reports", AdminRouteScope.SCHOOL),
    Settings("Settings", AdminRouteScope.DISTRICT),
    Schools("Schools", AdminRouteScope.DISTRICT),
    Users("Users", AdminRouteScope.DISTRICT),
}
